const GLOBAL_HISTORY_NAMES = {
  MOBILE: 'storefront.pwa.mobile.global.history',
  DESKTOP: 'storefront.pwa.desktop.global.history',
}

export {
  GLOBAL_HISTORY_NAMES,
}
